import {customElement, property} from 'lit/decorators.js';
import {consume} from '@lit/context';
import {CSSResult, html, LitElement, nothing, unsafeCSS} from 'lit';
import styles from './action-menu-product-info.scss?inline';
import {sharedCss} from '../../../scripts/style-bundle/shared.js';
import {Messages} from '../../../@types/wishlist.js';
import {i18nContext} from '../../../scripts/context/i18nContext.js';
import {WishlistImage} from '../wishlist-image/wishlist-image.js';
import {productMenuContext} from '../../../scripts/context/menuContext.js';
import {ProductMenuState} from '../../../scripts/context/menu-state.js';

@customElement('ents-action-menu-product-info')
export class ActionMenuProductInfo extends LitElement {
  @consume({context: i18nContext})
  private messages!: Messages;

  @consume({context: productMenuContext, subscribe: true})
  @property({attribute: false})
  private productMenuState!: ProductMenuState;

  static get styles(): CSSResult[] {
    return [sharedCss, unsafeCSS(styles)];
  }

  getShownImage(): HTMLImageElement | null {
    const wishlistImageElement = this.shadowRoot?.querySelector('ents-wishlist-image') as WishlistImage | null;
    if (!wishlistImageElement) {
      return null;
    }
    return wishlistImageElement.shadowRoot?.querySelector('picture img') as HTMLImageElement ?? null;
  }

  render() {
    return html`
      <div class="ents-action-menu__product">
        <div class="ents-action-menu__product__image">
          <ents-wishlist-image
            image-url="${this.productMenuState.context.imageUrl}"
            sizes="(min-width: 1080px) 14vw, (min-width: 960px) 144px, (min-width: 760px) 72px, 30vw"
            alt-text="${this.productMenuState.context.product?.brandName} ${this.productMenuState.context.product?.name}"
            ?is-beauty="${this.productMenuState.context.product?.isBeauty === true}"
            brand-code="${this.productMenuState.context.product?.brandCode}"
          ></ents-wishlist-image>
        </div>
        <div class="ents-action-menu__product--information">
          <div class="ents-action-menu__product__brand ents-copy-small-bold ents-s:copy-bold"
               data-test-ents-action-menu-brand>
            ${this.productMenuState.context.product?.brandName}
          </div>
          <div class="ents-action-menu__product__name ents-copy-small"
               data-test-ents-action-menu-name>
            ${this.productMenuState.context.product?.name}
          </div>
          <div class="ents-action-menu__product__name ents-copy-small"
               data-test-ents-action-menu-subname>
            ${this.productMenuState.context.product?.subName}
          </div>
          ${this.productMenuState.context.product?.colorName ? html`
            <div class="ents-action-menu__product__color ents-copy-extra-small"
                 data-test-ents-action-menu-color>
              ${this.messages['ents_wishlist_product_color']} ${this.productMenuState.context.product?.colorName}
            </div>
          ` : nothing}
        </div>
      </div>
    `;
  }
}
